import React, { Component } from 'react';

export class BurnTradelanesEventComponent extends Component {

    componentDidMount() {
        this.props.app.gameController.gamePlayerOrbits.burnLanes();
    }

    done = () => {
        this.props.eventComplete();
    }

    render() {
        return <></>;
    }

}
